// extracted by mini-css-extract-plugin
module.exports = {"noDataBanner":"styles_noDataBanner__QGG3w","supportLink":"styles_supportLink__6rvJ3"};